import React from "react"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Helmet } from "react-helmet"
import { useGetPagesDataQuery } from "redux/cms/api"
import CmsTab from "../Common/Tab"
function Riding() {
  const { data, isLoading, isSuccess, refetch } = useGetPagesDataQuery("riding")

  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "Riding",
      link: "/pages/riding",
    },
    paths: [
      {
        label: "Pages",
        link: "/pages/riding",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Riding | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <CmsTab
            data={data}
            isLoading={isLoading}
            isSuccess={isSuccess}
            tab={"Riding"}
            refetch={refetch}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Riding
